//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    config: { type: Object, required: true },
    design: { type: Object, required: true },
    designDetails: { type: Object, required: true },
    sku: { type: String, required: true }
  },
  data () {
    return {
      showDropdowns: false
    }
  },
  computed: {
    selections () { return this.$store.getters['bundle/selections'](this.config, this.designDetails, this.extraSKUs) },
    queryOptions () { return this.$store.getters['bundle/queryOptions'](this.config, this.designDetails, this.extraSKUs, this.sku) },
    price () { return this.$store.getters['bundle/price'](this.config, this.designDetails, this.extraSKUs) },
    extraSKUs () { return this.$store.getters['product/extraSKUs'](this.design, (this.sku || '').split('-')[0]) }
  },
  methods: {
    async addToCart (additionalProductSKU = null) {
      const queryOptions = this.queryOptions
      if (additionalProductSKU) queryOptions.related_product_sku = additionalProductSKU
      const success = await this.$store.dispatch('cart/ADD_TO_CART', [queryOptions, this.sku])
      if (success) {
        this.$store.commit('cart/SET_SKIP_FETCH_CART_STATE', true)
        this.$router.push({ path: this.localePath('/checkout/cart/') })
      }
    }
  }
}
